import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'markant-platform-ui-card-item',
  templateUrl: './ui-card-item.component.html',
  standalone: true,
  imports: [CommonModule],
  styleUrls: ['./ui-card-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UiCardItemComponent {
  @Input({ required: true }) label!: string;
  @Input() title?: string | number | boolean | null;
  @Input()
  @HostBinding('class.ui-card-item--inline')
  inline = false;
}
